import AssessmentsAdapter from './base';

export default class Assessment extends AssessmentsAdapter {
  modelNamePlural = 'assessments';
}
